import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {menu_collapsible_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/menu_collapsible_template";

import {appTitle_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/appTitle_template";

declare var ko: any;
declare var page: any;

export class menu_mod extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected menu_collapsible_template: menu_collapsible_template;

    protected getModuleName(){
        return "w-main-nav";
    }

    buildContent() : Array<Element>{

        // Create the logo and the title
        let appTitle = new appTitle_template("appTitle", this.viewModel, this);
        appTitle.setTitle("pubinsights");

        this.menu_collapsible_template = new menu_collapsible_template("mainMenu", this.viewModel, this);

        appTitle.setUrl('/');
        return [appTitle.build(), this.menu_collapsible_template.build()];
    }

    public fillPage() : void{

        let vnApp = this.getVnAppZone().app;

        if(vnApp.loggedUser.isLoggedIn) {
            this.getListData();
        }

    }

    public getListData(): void{

        this.menu_collapsible_template.activateLoading();

        let usrReq_url: string = '/api/menu/list_data';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateList(responseParsed);
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.menu_collapsible_template.deactivateLoading();
            }
        };
    }

    protected updateList(responseParsed: any){
        this.menu_collapsible_template.setMenus(responseParsed);
    }

    public getGlobalSelectedBrandMenuPage(id) {
        return '';
    }

    public getActiveMenus() {
        return [];
    }

    public setGlobalSelectedBrandMenuPage(id) {}

    public resetGlobalSelectedBrandMenuPage(): void {}

    // PubInsights does not persist expanded menu state, but the shared collapsible menu expects this hook.
    public handleActiveMenus(): void {}

    public getDefaultSectionId() {
        return '';
    }

    public setDefaultSectionId(sectionId): void {}
}



// WEBPACK FOOTER //
// ./js/modules/menu.ts